'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _app = require('./app.html');

var _app2 = _interopRequireDefault(_app);

require('./app.styl');

var _app3 = require('./app.controller');

var _app4 = _interopRequireDefault(_app3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appComponent = {
  restrict: 'E',
  bindings: {},
  template: _app2.default,
  controller: _app4.default,
  controllerAs: 'vm'
};

exports.default = appComponent;


// WEBPACK FOOTER //
// ./client/app/app.component.js